import { DEFAULT_ROWS_PER_PAGE } from "@interfaces/tables";
import { useState } from "react";

export const useTable = () => {
  const [anchorElement, setAnchorElement] = useState<Element | undefined>(
    undefined
  );

  const [page, setPage] = useState(0);

  const [selected, setSelected] = useState<string[]>([]);

  const [filterName, setFilterName] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);

  const handleOpenMenu = (event: any) => {
    setAnchorElement(event.target as Element);
  };

  const handleCloseMenu = () => {
    setAnchorElement(undefined);
  };

  const handleSelectAllClick = (event: any, fullList: string[]) => {
    if (event.target.checked) {
      setSelected(fullList);
      return;
    }
    setSelected([]);
  };

  const handleClick = (id: string) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event: any) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  return {
    anchorElement,
    setAnchorElement,
    page,
    setPage,
    selected,
    setSelected,
    filterName,
    setFilterName,
    rowsPerPage,
    setRowsPerPage,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectAllClick,
    handleClick,
    handleChangePage,
    handleChangeRowsPerPage,
    handleFilterByName,
  };
};
